// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getClientes as listClientesAPI,
    getCliente as getClienteAPI,
    addCliente as addClienteAPI,
    updateCliente as updateClienteAPI,
    deleteCliente as deleteClienteAPI,
    updateContacto as updateContactoAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { clientsApiResponseError, clientsApiResponseSuccess } from './actions';
import { ClientsActionTypes } from './constants';

import { contactosApiResponseError} from '../contactos/actions'
import { ContactosActionTypes} from '../contactos/constants'

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getCliente({ payload: { id } }) {
    try {
        const response = yield call(getClienteAPI, id );
        const cliente = response.data.data;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(clientsApiResponseSuccess(ClientsActionTypes.GET_CLIENT, cliente));
    } catch (error) {
        yield put(clientsApiResponseError(ClientsActionTypes.GET_CLIENT, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

function* addCliente({payload:cliente}){
    try{
        const dataToSend = {...cliente}
        const idContacto = dataToSend.id
        const response = yield call(addClienteAPI,dataToSend)
        const client = response.data
        yield put(clientsApiResponseSuccess(ClientsActionTypes.ADD_CLIENT,client))
        //UPdate contacto idClientInfotourist
        try{
            const dataToUpdate = {id:idContacto,idClientInfotourist:client.id}
            // console.log(dataToUpdate)
            yield call(updateContactoAPI,dataToUpdate)
        } catch(error){
            yield put(contactosApiResponseError(ContactosActionTypes.UPDATE_CONTACTO,error))
        }
    } catch(error){
        yield put(clientsApiResponseError(ClientsActionTypes.ADD_CLIENT,error))
    }
}

function* updateCliente({payload:cliente}){
    try{
        const response = yield call(updateClienteAPI,{...cliente})
        const client = response.data.data
        yield put(clientsApiResponseSuccess(ClientsActionTypes.UPDATE_CLIENT,client))
    }catch(error){
        yield put(clientsApiResponseError(ClientsActionTypes.UPDATE_CLIENT,error))
    }
}
function* deleteCliente({payload:{id}}){
    try{
        const response = yield call(deleteClienteAPI,id)
        const client = response.data.id
        yield put(clientsApiResponseSuccess(ClientsActionTypes.DELETE_CLIENT,client))
    }catch(error){
        yield put(clientsApiResponseError(ClientsActionTypes.DELETE_CLIENT,error))
    }
}

/**
 * List contactos
 */
function* listClientes() {
    try {
        const response = yield call(listClientesAPI);
        const listaClientes = response.data.data;
        yield put(clientsApiResponseSuccess(ClientsActionTypes.LIST_CLIENTS, listaClientes));
    } catch (error) {
        yield put(clientsApiResponseError(ClientsActionTypes.LIST_CLIENTS, error));
    }
}


export function* watchGetCliente(): any {
    yield takeEvery(ClientsActionTypes.GET_CLIENT, getCliente);
}

export function* watchListClientes(): any {
    yield takeEvery(ClientsActionTypes.LIST_CLIENTS, listClientes);
}

export function* watchAddCliente():any{
    yield takeEvery(ClientsActionTypes.ADD_CLIENT,addCliente)
}
export function* watchUpdateCliente():any{
    yield takeEvery(ClientsActionTypes.UPDATE_CLIENT,updateCliente)
}
export function* watchDeleteCliente():any{
    yield takeEvery(ClientsActionTypes.DELETE_CLIENT,deleteCliente)
}


function* clientesSaga(): any {
    yield all([
        fork(watchGetCliente),
        fork(watchListClientes),
        fork(watchAddCliente),
        fork(watchUpdateCliente),
        fork(watchDeleteCliente),
    ]);
}

export default clientesSaga;
